import React, { Component } from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import alphaO from "../Img/O.png";
import alphaT from "../Img/T.png";
import alphaE from "../Img/E.png";
import alphaR from "../Img/R.png";
import Dash from "../Img/Dash.png";

const Box = styled.div`
  width: 60%;
  max-width: 400px;
  display: flex;
  justify-content: center;
`;

const Bar = styled.img`
  color: rgba(24, 12, 12, 1);
  height: 10px;
  opacity: 0.3;
  margin: 5px;
`;

const Target = styled.img`
  color: rgba(24, 12, 12, 1);
  height: 10px;
  opacity: ${props => (props.stage === "/target" ? "1" : "0.3")};
  margin: 5px;
  transition: 0.4s ease-in-out;
`;

const Opinion = styled.img`
  color: rgba(24, 12, 12, 1);
  height: 10px;
  opacity: ${props => (props.stage === "/opinion" ? "1" : "0.3")};
  margin: 5px;
  transition: 0.4s ease-in-out;
`;

const Reason = styled.img`
  color: rgba(24, 12, 12, 1);
  height: 10px;
  opacity: ${props => (props.stage === "/reason" ? "1" : "0.3")};
  margin: 5px;
  transition: 0.4s ease-in-out;
`;
const Example = styled.img`
  color: rgba(24, 12, 12, 1);
  height: 10px;
  opacity: ${props => (props.stage === "/example" ? "1" : "0.3")};
  margin: 5px;
  transition: 0.4s ease-in-out;
`;
const Offer = styled.img`
  color: rgba(24, 12, 12, 1);
  height: 10px;
  opacity: ${props => (props.stage === "/offer" ? "1" : "0.3")};
  margin: 5px;
  transition: 0.4s ease-in-out;
`;

class Progress extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    const { stage } = this.props;
    // console.log(stage);
    return (
      <Box>
        <Target src={alphaT} stage={stage} className="disableDrag"></Target>
        <Bar src={Dash} className="disableDrag"></Bar>
        <Opinion src={alphaO} stage={stage} className="disableDrag"></Opinion>
        <Reason src={alphaR} stage={stage} className="disableDrag"></Reason>
        <Example src={alphaE} stage={stage} className="disableDrag"></Example>
        <Offer src={alphaO} stage={stage} className="disableDrag"></Offer>
      </Box>
    );
  }
}

export default Progress;
